import(/* webpackMode: "eager", webpackExports: ["DevtoolsProvider"] */ "/vercel/path0/node_modules/creatr-devtools/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/font/local/target.css?{\"path\":\"node_modules/geist/dist/sans.js\",\"import\":\"\",\"arguments\":[{\"src\":\"./fonts/geist-sans/Geist-Variable.woff2\",\"variable\":\"--font-geist-sans\",\"weight\":\"100 900\"}],\"variableName\":\"GeistSans\"}");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/FeedbackButton.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/styles/globals.css");
